export enum FileType {
  IMAGE = 'image',
  PDF = 'pdf',
  CSV = 'csv',
  JSON = 'json',
  XML = 'xml',
  GPC = 'gpc',
  TXT = 'txt',
  WORD = 'word',
  EXCEL = 'excel',
  OTHER = 'other',
}
